import { Button, Modal } from '@alphonsocode/kallos';
import React from 'react';
import { BsClipboard } from 'react-icons/bs';

export function LogPreviewModal({ open, setOpen, logs }) {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(logs);
  };

  const getColorForLevel = line => {
    return '#333';
  };

  return (
    <Modal.Root open={open}>
      <Modal.Overlay />
      <Modal.Dialog size={'xl'}>
        <Modal.Header closeButton={true} onClick={() => setOpen(false)}>
          <Modal.Title style={{ fontSize: '22px' }}>Log Preview</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ position: 'relative', paddingTop: '40px' }}>
          {/* Copy Button */}
          <Button
            onClick={copyToClipboard}
            variant="borderless"
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              zIndex: 10,
            }}
          >
            <BsClipboard />
            Copy
          </Button>

          {/* Logs */}
          <div
            style={{
              fontFamily: 'monospace',
              fontSize: '14px',
              backgroundColor: '#f9f9f9',
              padding: '16px',
              borderRadius: '8px',
              maxHeight: '400px',
              overflowY: 'auto',
              whiteSpace: 'pre-wrap',
              lineHeight: '1.5',
            }}
          >
            {logs
              .trim()
              .split('\n')
              .map((line, index) => (
                <div key={index} style={{ color: getColorForLevel(line) }}>
                  {line}
                </div>
              ))}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="col-6"></div>
          <div className="d-flex justify-content-end gap-2 col-6 footer">
            <div className="col-3">
              <Button
                onClick={() => setOpen(false)}
                variant="outlined"
                style={{ width: '100%' }}
              >
                Close
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal.Root>
  );
}
